import { MenuService } from './../bootstrap/menu.service';
import { LocalStoreEnum } from '@shared/models/enum/local-store.enum';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
/****************************************************
 *** description: route guard to check permission to an url
 *****************************************************/
export class PermissionDformGuard implements CanActivate {

  constructor(
    private router: Router,
    private menu: MenuService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const menuList: any[] = JSON.parse(localStorage.getItem(LocalStoreEnum.Menu_List));
    const nextUrl = this.menu.removeURLParameter(state.url);
    const havePermission = (menuList || []).find(item => nextUrl === ('/' + item.route));
    if (!havePermission) {
      this.router.navigate(['pl/notfound']);
      return false;
    }
    return true;
  }
}
